export const images = {
    logo : require('./images/Logo.png'),    
  }
